import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { EditionDocumentationView } from "./EditionDocumentationView";
import { EditionDocumentationViewStore } from "../../store/EditionDocumentationViewStore";
import { useStore } from "../../../../hooks";

export const EditionDocumentationViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/editionDocumentation/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new EditionDocumentationViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <EditionDocumentationView editionDocumentationViewStore={store} />
      </PageLayout>
    </div>
  );
});
